import Intro from "../components/Intro";
import { connect } from "react-redux";
import { selectScroll } from "../state/selectors";

const mapStateToProps = state => {
  if (typeof window !== "undefined") {
    const h = window.innerHeight;
    const scrolledPercent = Math.min(1, selectScroll(state) / h);
    const grad1 = 60 - scrolledPercent * 120;
    const grad2 = 75 - scrolledPercent * 60;
    const grad3 = 78 - scrolledPercent * 30;

    return {
      style: {
        "--grad-1": `${grad1}%`,
        "--grad-2": `${grad2}%`,
        "--grad-3": `${grad3}%`
      }
    };
  }
  return {};
};

export default connect(mapStateToProps)(Intro);



// WEBPACK FOOTER //
// ./src/containers/AnimatedIntro.js